import { RecipientDto } from '../../../../../interfaces/dtos/RecipientDto';

export default function transformRecipients(dtos: RecipientDto[], isAnotherRecipient = false): string {
  if (!dtos || dtos.length === 0) return null;

  if (isAnotherRecipient) return getAnotherRecipient(dtos.filter((r) => !r.isMainRecipient));

  const main = dtos.find((r) => r.isMainRecipient).extranetUser;
  return `${main?.firstName} ${main?.lastName}`;
}

function getAnotherRecipient(dtos: RecipientDto[]): string {
  const results: string[] = [];
  dtos.forEach((dto) => {
    results.push(`${dto.extranetUser?.firstName} ${dto.extranetUser?.lastName}`);
  });

  return results.join(', ');
}
